<script>
    import { a } from '../../../shared/globalState/a';
    import CloseIcon from '../tomat/icons/CloseIcon.svelte';
    import { linear } from 'svelte/easing';
    import { scale} from 'svelte/transition';

    export let isVisible;
    export let title;
    export let message;

    let tic = 'h-5 w-5 text-slate-500';

    let transitionOptions = {
        duration: 100,
        easing: linear,
    };

    function closeDelay(){
        setTimeout(() => {
            close();
        }, 3000);
    }

    function close(){
        a.showErrorDialog$.next({isVisible: false});
    }



    
</script>

{#if isVisible}
    <div class="dialog-container" transition:scale={transitionOptions} use:closeDelay>
        <div class="flex-row">
            <button on:click={close}>
                <CloseIcon {tic}></CloseIcon>
            </button>
        </div>
        <div class="title-container">
            <span>{title}</span>
        </div>
        <div class="message-container">
            <p>{message}</p>
        </div>
    </div>
{/if}

<style>
    .dialog-container {
        position: absolute;
        z-index: 50;
        transform: translate(50%, calc(100vh - 200px));
        width: 40%;
        border: 1px solid slategray;
        border-radius: 5px;
        background-color: #f4433661;
        padding: 0.5em 0.5em 1em 1em;
    }
    .title-container {
        font-size: 2em;
    }
    .message-container {
        font-size: 18px;
        line-height: 1.5;
        color: #333;
    }
    .flex-row {
        justify-content: end;
    }
</style>
